<template>
  <div
    :class="`snackbar__${position} snackbar__${type}`"
    :id="`snackbar-${id}`"
    class="is-flex is-justify-content-space-between snackbar"
  >
    <div
      class="
        is-align-items-center
        is-flex
      "
    >
      <i
        :class="icon"
        class="is-size-4 mr-4"
      />
      <section class="
        is-flex
        is-flex-direction-column
      ">
        <span v-if="title" class="mb-1">
          {{ title }}
        </span>
        <span class="has-text-weight-light snackbar__message">
          {{ msg }}
        </span>
      </section>
    </div>
    <b-button
      v-if="showClose"
      class="snackbar__close"
      type="is-ghost"
      @click="close"
    >
      <i class="icon-cross" />
    </b-button>
  </div>
</template>

<script>
import Snackbar from './Snackbar';

export default Snackbar;
</script>

<style lang="scss" scoped>
@import 'Snackbar';
</style>
